import React, { useContext } from "react";
import _ from "lodash";

import makeStyles from '@mui/styles/makeStyles';
import Typography from "@mui/material/Typography";
import { Container } from "@mui/material";
import Grid from "@mui/material/Grid";

import UpcomingContentCard from "../UpcomingContentCard";
import LanguageContext from "../../LanguageContext";
import messages from "../../services/messages";
import Skeleton from '@mui/material/Skeleton';
import SectionTitle from "../SectionTitle";
import UpcomingContentCardHorizontal from "../UpcomingContentCardHorizontal";

const useStyles = makeStyles((theme) => ({
  root: {
    // display: "flex",
    marginTop: theme.spacing(4),
  },
  rootNotTopPadding: {},
  contentCard: {
    marginLeft: theme.spacing(2),
  },
  Container: {
    marginTop: theme.spacing(1),
  },
}));

export default function UpcomingListContainer(props) {
  const classes = useStyles();
  const language = useContext(LanguageContext);
  // const [open, setOpen] = React.useState(true);

  // const handleClick = () => {
  //   setOpen(!open);
  // };
  return (
    <div
      className={props.noTopPadding ? classes.rootNotTopPadding : classes.root}
    >
      <Container>
        {!props.hideTitle && (
          <SectionTitle
            icon={"icons/upcoming.svg"}
            title={messages["dashboard.upcoming.sectionTitle"][language]}
          />
        )}

        <div className={classes.Container}>
          <Grid
            container
            direction="row"
            justifyContent="flex-start"
            alignItems="flex-start"
            spacing={2}
          >
            {_.map(props.allUpcomingMeetings, (upcomingMeeting, index) => {
              return (
                <Grid item xs={12} sm={6} md={4} lg={3} key={index}>
                  <UpcomingContentCardHorizontal
                    upcomingMeeting={upcomingMeeting}
                    position={index + 1}
                    userType={props.userType}
                    farmerCrops={props.farmerCrops}
                    userSource={props?.userSource}
                    userState={props.userState}
                  />
                </Grid>
              );
            })}

            {props.loading && (
              <>
                <Grid item xs={12} sm={12} md={6} lg={4}>
                  <Skeleton variant="rectangular" height={200} />
                </Grid>
              </>
            )}

            {!props.loading && _.isEmpty(props.allUpcomingMeetings) && (
              <Grid item xs={12} sm={12} md={12}>
                <Typography variant={"body2"}>
                  {messages["dashboard.upcoming.noSession"][language]}
                </Typography>
              </Grid>
            )}
          </Grid>
        </div>
      </Container>
    </div>
  );
}
